<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdperfil) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption" for="nmtpdoc">Nome do Perfil</label>
                <input type="text" v-model="objEdicao.nmperfil" id="nmtpdoc" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Ativo</label>
                <select v-model="objEdicao.ativo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Padrão Estabelecimento</label>
                <select v-model="objEdicao.ckpadrao_estab">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Padrão RT</label>
                <select v-model="objEdicao.ckpadrao_rt">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>


            <div class="form-item-char20">
                <label class="label-caption">Escopo de Acesso</label>
                <select v-model="objEdicao.cdescopo">
                    <option value=1>Consórcio/Entidade</option>
                    <option value=2>S.I.M.</option>
                    <option value=3>Estabelecimento</option>
                </select>
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="detalhamento">Informações do Perfil</label>
                <textarea v-model="objEdicao.informacoes" id="detalhamento" maxlength="3000" rows="5" style="resize: none;"/>
            </div>
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="closeForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { Api } from '@/funcoes/apiExport';
import { criarUsuarioPerfil } from '@/models/usuarioPerfil';
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarUsuarioPerfil());

function closeForm() {emit('close');}

async function lerDados() {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('usuario_perfil', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value=false;}
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;
        const response  = await Api.genericPut('/cad/usuario_perfil', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


function validarDados(){
    let r = Validar.texto(objEdicao.value.nmperfil, 'Informe nome do perfil');
    if (!r.ok) return r.msg;
    return null;
}

onMounted(lerDados);
</script>